<template>
<div class="target">
    <div class="card card-flush pb-0 bgi-position-y-center bgi-no-repeat mb-10"  :style="{backgroundSize: 'auto calc(100% + 10rem)', backgroundPositionX: '100%', backgroundImage: 'url(' + imgEvent + ')'}">
        <!--begin::Card header-->
        <div class="card-header pt-10 bg-transparent border-0">
            <div class="d-flex align-items-center">
                <!--begin::Icon-->
                <div class="symbol symbol-circle mr-3">
                    <div class="symbol-label bg-transparent text-primary border border-secondary border-dashed">
                        <!--<span class="svg-icon svg-icon-primary svg-icon-2x">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <polygon points="0 0 24 0 24 24 0 24" />
                                    <path d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z" fill="white" fill-rule="nonzero" transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) " />
                                </g>
                            </svg>
                        </span>-->

                        <span class="svg-icon svg-icon-2x svg-icon-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M17.302 11.35L12.002 20.55H21.202C21.802 20.55 22.202 19.85 21.902 19.35L17.302 11.35Z" fill="#009ef7"></path>
                                <path opacity="0.3" d="M12.002 20.55H2.802C2.202 20.55 1.80202 19.85 2.10202 19.35L6.70203 11.45L12.002 20.55ZM11.302 3.45L6.70203 11.35H17.302L12.702 3.45C12.402 2.85 11.602 2.85 11.302 3.45Z" fill="#009ef7"></path>
                            </svg>
                        </span>
                    </div>
                </div>
                <!--end::Icon-->
                <!--begin::Title-->
                <div class="d-flex flex-column">
                    <h2 class="mb-1">Participar en eventos</h2>
                    <span class="text-muted">Recuerde que cada formulario tiene una fecha de expiración</span>
                    <!--<div class="text-muted fw-bolder">
                        <a href="#">Keenthemes</a>
                        <span class="mx-3">|</span>
                        <a href="#">File Manager</a>
                        <span class="mx-3">|</span>2.6 GB
                        <span class="mx-3">|</span>758 items
                    </div>-->
                </div>
                <!--end::Title-->
            </div>
        </div>
        <!--end::Card header-->
        <!--begin::Card body-->
        <div class="card-body py-0">
            <!--begin::Navs-->
            <div class="d-flex overflow-auto h-55px">
                <el-select v-model="hfilter.anio" class="w-100 w-sm-100px w-md-100px mr-2" placeholder="Periodo" @change="getEvents">
                    <el-option v-for="item in periods" :key="item.periodo" :label="item.periodo" :value="item.periodo">
                    </el-option>
                </el-select>

                <el-radio-group v-model="hfilter.tpoevent" @change="getEvents" class="mr-2">
                    <el-radio-button v-for="item in tpoevent" :key="item.id" :label="item.id" class="mb-0">{{item.name}}</el-radio-button>
                </el-radio-group>

                <el-select v-model="hfilter.idevent" placeholder="Seleccione un evento" class="w-100 w-md-400px" @change="getConfigForms">
                    <el-option v-for="item in listEvents" :key="item.idevent" :label="item.name" :value="item.idevent"></el-option>
                </el-select>
            </div>
            <!--begin::Navs-->
        </div>
        <!--end::Card body-->
    </div>

    <div class="card card-custom mb-7 d-none">
        <div class="card-header border-0">
            <h3 class="card-title"><span class="card-label font-weight-bolder text-dark">Participar en eventos</span></h3>
            <div class="card-toolbar">

            </div>
        </div>
    </div>
    <div class="d-lg-flex flex-row-fluid">
        <div class="flex-column offcanvas-mobile w-300px w-xl-325px">
            <div class="card card-custom card-stretch" v-loading="loading">
                <div class="card-header border-0">
                    <h3 class="card-title align-items-start- flex-column-">
                        <span class="card-label font-weight-bolder text-dark"> Formularios </span>
                        <!--<span class="text-muted mt-3 font-weight-bold font-size-sm"></span>-->
                    </h3>
                </div>
                <div class="card-body card-stretched p-3">
                    <el-empty v-if="listForms.length==0" :image-size="100"></el-empty>
                    <ul v-else class="nav nav-light-primary nav-bold nav-pills">
                        <div v-for="item in listForms" :key="item.formid" class="w-100">
                            <li v-if="item.available ==1 " class="nav-item w-100 mb-3">
                                <div class="nav-link btn text-left active p-2 align-items-stretch" 
                                :class="{'bg-light-success border border-success' : item.status}" 
                                @click.prevent="setActive(item.formid)">
                                    <div class="nav-icon px-2 d-flex align-items-center mr-3">
                                        <h1 class="m-0" v-text="item.formid"></h1>
                                    </div>
                                    <div>
                                        <div class="nav-text text-dark font-weight-bolder" v-text="item.formname"></div>
                                        <div class="nav-text text-dark-50" v-text="item.subtitle"></div>
                                    </div>
                                    
                                </div>
                            </li>
                            <li v-else class="nav-item w-100 mb-3">
                                <div class="nav-link btn text-left disabled bg-secondary">
                                    <span class="nav-icon">
                                        <h1 class="m-0" v-text="item.formid"></h1>
                                    </span>
                                    <span class="nav-text" v-text="item.formname"></span>
                                </div>
                            </li>
                        </div>
                    



                        <!--<li class="nav-item w-100">
                            <div class="nav-link btn text-left" @click.prevent="setActive('tab2')" :class="{ active: isActive('tab2') }">
                                <span class="nav-icon">
                                    <h1 class="m-0">2</h1>
                                </span>
                                <span class="nav-text">Formulario para deportes Individuales</span>
                            </div>
                        </li>
                        <li class="nav-item w-100">
                            <div class="nav-link btn text-left" @click.prevent="setActive('tab3')" :class="{ active: isActive('tab3') }">
                                <span class="nav-icon">
                                    <h1 class="m-0">3</h1>
                                </span>
                                <span class="nav-text">Deportistas y Oficiales Técnicos</span>
                            </div>
                        </li>
                        <li class="nav-item w-100">
                            <div class="nav-link btn text-left" @click.prevent="setActive('tab4')" :class="{ active: isActive('tab4') }">
                                <span class="nav-icon">
                                    <h1 class="m-0">3</h1>
                                </span>
                                <span class="nav-text">Oficiales Administrativos</span>
                            </div>
                        </li>-->
                    </ul>
                </div>

            </div>
        </div>

        <div class="flex-row-fluid ml-lg-8">
            <!--<div class="card card-custom" v-loading="loading" :class="{ 'active show': isActive('tab2') }">
                <div class="card-header border-0">
                    <h3 class="card-title align-items-start- flex-column-">
                        <div class="d-flex align-items-center mr-3">
                            <div href="#" class="d-flex align-items-center text-dark  font-size-h5 font-weight-bolder mr-3">Formulario de Intencion de Participación</div>
                            <span class="label label-light-success label-inline font-weight-bolder mr-1">Aprobado</span>

                        </div>
                    </h3>
                    <div class="card-toolbar">

                    </div>
                </div>
                <div class="card-body">
                    <el-empty v-if="listEvents.length==0" :image-size="400"></el-empty>
                    <div class="tab-content">
                        kjkhjkh

                    </div>
                </div>

            </div>-->
            <div class="card card-custom" v-if="isActive('0')">
                <div class="card-body">
                    <el-empty :image-size="400"></el-empty>
                </div>
            </div>

            <Intention v-if="isActive(1)" :title="title" :idevent="hfilter.idevent"></Intention>
            <Quantitative v-if="isActive(2)" :title="title" :idevent="hfilter.idevent"></Quantitative>
            <Nominal v-if="isActive(3)" :title="title" :idevent="hfilter.idevent"></Nominal>

            <!--<Administrative v-if="isActive('tab3')"></Administrative>-->

        </div>

    </div>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import {
    ACREDITATION
} from "@/store/acreditation.module";
import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";
import code from "@/core/config/status.code";

//services
import acrService from '@/core/services/acr.service'; //✓

//components
import Intention from '@/components/forms_participate/Intention';
import Administrative from '@/components/forms_participate/Administrative';
import Quantitative from "@/components/forms_participate/Quantitative";
import Nominal from "@/components/forms_participate/Nominal";

export default {
    name: 'athlete',
    components: {
        Intention,
        Quantitative,
        Administrative,
        Nominal,
    },
    data: () => ({
        loading: false,
        listForms: [],
        listEvents: [],
        listSports: [],
        allAthlete: 0,
        hfilter: {
            anio: null,
            tpoevent: null,
            idevent: null,
            idgroup: 0,
            idsport: null
        },
        activeItem: '0',
        imgEvent: 'https://preview.keenthemes.com/metronic8/demo2/assets/media/illustrations/sigma-1/4.png',
        title: null
    }),
    computed: {
        ...mapGetters(['currentAcreditation', 'tpoevent', 'periods']),
    },
    mounted() {

    },
    methods: {
        isActive(menuItem) {
            return this.activeItem === menuItem
        },
        setActive(menuItem) {
            this.activeItem = menuItem;
            let _title = this.listForms.filter(item => item.formid === menuItem)
            this.title = Object.assign({}, ..._title);
            this.title = this.title.formname;
        },
        async getEvents() {
            try {
                if (this.hfilter.anio != null && this.hfilter.tpoevent != null) {
                    this.$Progress.start();
                    this.imgEvent = 'https://preview.keenthemes.com/metronic8/demo2/assets/media/illustrations/sigma-1/4.png';
                    this.setActive('0');
                    this.hfilter.idevent = null;
                    this.listForms.length = 0;
                    const res = await acrService.Events(this.hfilter);
                    this.listEvents = res.data;
                    this.$Progress.finish();

                    if (this.listEvents.length == 0)
                        this.$message.error('Lo sentimos, no se encontraron eventos.')
                }
            } catch (e) {
                this.$Progress.finish();
                if (e instanceof acrError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        async getConfigForms() {
            try {
                if (this.hfilter.idevent == null)
                    return false;

                this.loading = true;
                let mela = this.listEvents.filter(ok => ok.idevent === this.hfilter.idevent);
                mela = Object.assign({}, ...mela);
                this.imgEvent = (mela.logo !='') ? mela.logo : this.imgEvent;


                const res = await acrService.configForms(this.hfilter);
                this.listForms = res.data;
                this.loading = false;
            } catch (e) {
                console.log(e);
                if (e instanceof acrError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }

            /*try {
                this.listForms = [
                    {'s': 'b'}
                ];
                this.allAthlete = 0;
                this.series[0].data.slice();
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                const res = await UniService.Sports(this.hfilter.idevent);
                this.listSports = res.data;

                this.listSports.forEach(element => {
                    this.allAthlete += parseInt(element.total);
                    this.series[0].data.push(element.total);
                    this.chartOptions.xaxis.categories.push(element.name);
                });
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof AuthenticationError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }*/
        },
        async getSports() {
            try {
                if (this.hfilter.idevent == null)
                    return false;

                this.loading = true;
                const res = await acrService.Sports(this.hfilter);
                //this.listSports = res.data;
                this.loading = false;

            } catch (e) {
                this.loading = false;
                if (e instanceof acrError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },

        goSportView(id, tag) {
            if (tag == null || tag == '')
                return this.$message.error('Lo sentimos, la vista se encuentra en mantenimiento');
            this.hfilter.idsport = id;
            this.$store.dispatch(ACREDITATION, this.hfilter);
            this.$router.push({
                name: tag
            })
        },
    },
    created() {
        this.hfilter.anio = (this.periods.length > 0) ? this.periods[0].periodo : null;
        this.hfilter.tpoevent = (this.tpoevent.length > 0) ? 'INT' : null;
        this.getEvents();
    }
}
</script>
